import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./NoInternetConnectionWarning.styles";
import CloudOffOutlinedIcon from "@mui/icons-material/CloudOffOutlined";

export const NoInternetConnectionWarning = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.warningContainer}>
            <CloudOffOutlinedIcon className={classes.icon} />
            <Typography className={classes.warningTitle} variant="subtitle2">
                {t("HMI.no_connection_to_the_server")}
            </Typography>
        </Box>
    );
};
